var map = {
	"./fr-audi/productPage.json": 85410,
	"./fr-cupra/productPage.json": 24194,
	"./fr-seat/productPage.json": 34994,
	"./fr-skoda/productPage.json": 60063,
	"./fr-vw/productPage.json": 9664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63858;